
import activeLicenseTabOn from "../../../assets/images/classes/activeLicenseTabOn.png";
import activeLicenseTabOff from "../../../assets/images/classes/activeLicenseTabOff.png";
import licenseHistoryTabOn from "../../../assets/images/classes/licenseHistoryTabOn.png";
import licenseHistoryTabOff from "../../../assets/images/classes/licenseHistoryTabOff.png";
import registrationTabOn from "../../../assets/images/classes/registrationTabOn.png";
import registrationTabOff from "../../../assets/images/classes/registrationTabOff.png";
import TabButton from "../../../components/TabButton";

const LicenseNavigation = ({activeTab, setActiveTab, setIsEditable}) => {

    const handleTabClick = (tab) => {
        setIsEditable(false);
        setActiveTab(tab);
    };

    return (
        <div className="flex flex-wrap justify-center items-center mt-[60px] min-h-[52px]">
            <TabButton
                on={registrationTabOn}
                off={registrationTabOff}
                active={activeTab === 'registration'}
                line={114}
                onClick={() => handleTabClick('registration')}/>
            <div
                className="flex items-center gap-1.5 self-stretch my-auto font-medium whitespace-nowrap min-h-[46px] text-stone-300">ㅣ
            </div>
            <TabButton
                on={activeLicenseTabOn}
                off={activeLicenseTabOff}
                active={activeTab === 'activeLicense'}
                line={114}
                onClick={() => handleTabClick('activeLicense')}/>
            <div
                className="flex items-center gap-1.5 self-stretch my-auto font-medium whitespace-nowrap min-h-[46px] text-stone-300">ㅣ
            </div>
            <TabButton
                on={licenseHistoryTabOn}
                off={licenseHistoryTabOff}
                active={activeTab === 'licenseHistory'}
                line={114}
                onClick={() => handleTabClick('licenseHistory')}/>
        </div>
    )
}


export default LicenseNavigation;